import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { practiceFeatures } from "../config/practice";
import { OLD_PATH_REDIRECTS } from "./inboxQueues";

// The old Communication / Onboard / Messaging URLs when the unified Inbox is
// on (features.unifiedInbox; routes/routes.js): straight to the matching
// /inbox path, query string kept, replacing the history entry.
export function inboxRedirect(to) {
  function InboxRedirect() {
    const location = useLocation();
    return <Navigate to={`${to}${location.search || ""}`} replace />;
  }
  return InboxRedirect;
}

// The component routes/routes.js mounts on an old path (/fax, /onboarding,
// /messaging): the redirect when the practice has the Inbox, else the old
// page itself, untouched (7825).
export function inboxOrOldPage(path, component, features = practiceFeatures()) {
  return features.unifiedInbox && OLD_PATH_REDIRECTS[path] ? inboxRedirect(OLD_PATH_REDIRECTS[path]) : component;
}

export default inboxRedirect;
